import React from "react";
import SportsFootballIcon from "@material-ui/icons/SportsFootball";
import possessionIndicatorStyles from "../styles/PossessionIndicator.styles";

const PossessionIndicator = ({ hasPossession, teamName }) => {
	const classes = possessionIndicatorStyles();

	return hasPossession ? (
		<SportsFootballIcon
			id={`${teamName}-possession-indicator`}
			color="secondary"
			className={classes.ball}
		/>
	) : null;
};

export default PossessionIndicator;
